// CNAEs pré-aprovados para Totvs Moda (têxtil=13, vestuário=14)
export const CNAES_PRE_APROVADOS = ['13', '14'];

export function qualificarCnae(codigo) {
  if (!codigo) return null;
  const prefixo = String(codigo).replace(/\D/g, '').slice(0, 2);
  return CNAES_PRE_APROVADOS.includes(prefixo) ? 'aprovado' : 'consultar';
}

// Verifica se algum CNAE secundário é pré-aprovado quando o principal não é
export function temSecundarioAprovado(cnaesSecundarios = []) {
  if (!Array.isArray(cnaesSecundarios)) return false;
  return cnaesSecundarios.some(c => qualificarCnae(c.codigo || c.id) === 'aprovado');
}

export function labelCnae(status) {
  if (status === 'aprovado') return '✅ Têxtil/Moda';
  if (status === 'consultar') return '⚠️ Consultar';
  return null;
}
